module.exports = __webpack_public_path__ + "img/calc.ad68759f.svg";